<template>
    <div class="page bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="content">
            <div class="card flex pd-200">
                <div class="flex1 text-center">
                    <div class="phone-img">
                        <img :src="phoneImg" alt="">
                    </div>
                    <div class="mt-10 fs-30 color-666">电话客服</div>
                    <div class="mt-10 fs-26 color-666">服务时间 9:00-18:30</div>
                </div>
            </div>

            <div class="card mt-20">
                <div class="card-title">我要反馈</div>
                <div class="pd-25">
                    <div class="option-list">
                        <div class="option-item" :class="{'active': curOption == item.value}" v-for="(item,$index) in optionList" :key="$index" @click="curOption = item.value">{{item.name}}</div>
                    </div>
                    <textarea placeholder="您可以在这里输入内容" class="contact-advice" v-model="formItem.content"></textarea>
                    <div class="flex filed-input-box" style="flex-wrap: wrap;">
                        <div class="pic-box" v-for="(item,$index) in formItem.imgList" :key="item.fileId">
                            <img :src="item.fileUrlView" alt="">
                            <div class="clean" @click="delImg($index)"></div>
                        </div>
                        <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false"
                                      :after-read="afterRead" v-show="formItem.imgList.length < 5"/>
                    </div>
                </div>
            </div>
            <div class="card mt-20 mb-20 pd-025">
                <div class="input-field bd-bot">
                    <div class="fs-32 color-333 left required">联系方式</div>
                    <van-field class="input" type="tel" :clearable="true" v-model="formItem.mobile" placeholder="输入您的手机号" />
                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="submitForm()">提交</div>
        </div>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import uploadImg from "@/api/uploadImg"
    import {submitFeedback} from "@/api/user"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "contact",
        components:{backTitleBar},
        mixins:[inputFix],
        data(){
            return{
                phoneImg: require("../../assets/images/contact/phone.png"),
                optionList:[
                    {name:'功能建议',value:'1'},
                    {name:'内容建议',value:'2'},
                    {name:'BUG反馈',value:'3'},
                    {name:'界面建议',value:'4'},
                    {name:'交互建议',value:'5'},
                    {name:'其他',value:'6'},
                ],
                curOption: '1',
                formItem:{
                    imgList:[],
                    content:''
                },
                imgList:[]
            }
        },
        methods:{
            //删除图片
            delImg($index){
                this.formItem.imgList.splice($index,1)
            },
            //选中图片后上传服务器
            async afterRead(file){
                console.log(file)
                let result = await uploadImg(file.file,'feedback')
                this.formItem.imgList.push(result)
            },
            submitForm(){
                let form = this.formItem;
                if(!form.content){
                    this.$toast("请填写建议");
                    return
                }
                if(!form.mobile){
                    this.$toast("请填写联系方式");
                    return
                }
                let params = {
                    content: form.content,
                    mobile: form.mobile,
                    addImgIds: this.formItem.imgList.map(item=>{
                        return item.fileId
                    }).join(','),
                    fromChannel: 3
                }
                submitFeedback(params).then(res=>{
                    if(res.code == 0){
                        this.$toast('提交成功');
                        this.$router.push({name: 'contactSuccess'});
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .24rem;
    }
    .phone-img{
        width: 1.2rem;
        height: 1.2rem;
        margin: auto;
    }
    .option-list{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .option-item{
            width: 2rem;
            text-align: center;
            background: #F1F1F1;
            border-radius: .12rem;
            font-size: .28rem;
            color: #333;
            line-height: .72rem;
            margin-right: .24rem;
            margin-bottom: .24rem;
            &:nth-child(3n){
                margin-right: 0;
            }
            &.active{
                background: $main-color;
                color: #fff;
            }
        }
    }
    .contact-advice{
        padding-top: .3rem;
        font-size: .32rem;
        line-height: .4rem;
        color: #666;
        width: 100%;
        height: 3rem;
        background: none;
        border: none;
        outline: none;
        resize: none;
    }
</style>



// WEBPACK FOOTER //
// contact.vue?36a39ce7